/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { LOG_SELECTED_GOOGLE_ADDRESS } from './GoogleAddressSearch-ActionTypes';

export const logSelectedGoogleAddress = (selectedAddress) => ({
    type: LOG_SELECTED_GOOGLE_ADDRESS,
    data: {
        selectedAddress,
    },
});

export default {};
